// tslint:disable:max-line-length
import { neo } from './core/neo';
import { NeoConfig } from './core/config';
import { GetPrefetchDataOptions } from './core/prefetch-data-tunnel';
import { env, EnvProperties } from './context/env';
import params from './context/params';
import { sharkFetch, downgrade } from './bridge';
import { NeoError } from './util/neo-error';
import { DebugLevel } from './util/debug';
import {
  stat,
  StatChannel,
  StatReportType,
  StatErrorLevel,
  StatErrorCategory,
  ReportChannelParams,
} from './stat';

export const init = <T>(config: NeoConfig) => neo.init<T>(config);
export const showWebview = () => neo.showWebview();
export const getPrefetchData = (
  key: string = 'default',
  options: GetPrefetchDataOptions = {}
) => neo.getPrefetchData(key, options);
export const getEnv = (): EnvProperties => env.getEnv();
export const getParams = () => params.getParams();
export { sharkFetch, downgrade };
export const isNeoError = NeoError.isNeoError;
export { DebugLevel };
export const report = (
  channel: StatChannel,
  labOrTags?: any,
  channelParam?: ReportChannelParams
) => {
  stat.report(channel, labOrTags, channelParam);
};
export { StatChannel, StatReportType, StatErrorLevel, StatErrorCategory };

export default {
  init,
  getPrefetchData,
  getEnv,
  getParams,
  sharkFetch,
  downgrade,
  showWebview,
  isNeoError,
  DebugLevel,
  report,
  StatChannel,
  StatReportType,
  StatErrorLevel,
  StatErrorCategory,
};
